import { render } from "./NoteComponent.vue?vue&type=template&id=50ff4bd6"
import script from "./NoteComponent.vue?vue&type=script&lang=js"
export * from "./NoteComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__